import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TranslationContext from "../../providers/TranslationContext";
import ValidationContext from "../../providers/ValidationContext";
import { validateField } from "../../validation/formValidation";

require("./TextBox.css");

interface Props {
  label?: string;
  placeholder: string;
  id?: string;
  defaultValue?: any;
  value?: any;
  dataField: string;
  isPassword?: boolean;
  isNumber?: boolean;
  formData?: any;
  setStateMethod?: any;
  disabled?: boolean;
  justifyContent?: any;
  textAlign?: any;
  width?: string;
  handleCheckedChange?: any;
  customLeftCols?: any; // for example col-sm-3
  customRightCols?: any; // for example col-sm-9
  isRequired?: boolean;
  autoComplete?: string;
  min?: number;
  max?: number;
  step?: number;
}

export const TextBox = (props: Props) => {
  const { t } = useTranslation();
  const [type, setType] = useState(props.isPassword ? 'password' : 'text'); // switch for password
  const [icon, setIcon] = useState(<i className="far fa-eye"></i>);

  const popupModel = useContext(TranslationContext) as any;
  const prefix = popupModel.prefix;

  const [isValid, setIsValid] = useState(true);
  const [validationModel, setValidationModel] = useState<any>();
  const [isRequired, setIsRequired] = useState(false);
  let leftColumnClass = `${props.customLeftCols ?? "col-sm-3"
    } col-form-label zvlabel`;

  let rightColumnClass = `${props.customRightCols ?? "col-sm-9"}`;

  let valueProps = props.value == undefined ? {} : {
    value: props.value
  };

  let possibleRangeProps = {};

  if (props.min != undefined && props.max != undefined && props.step != undefined) {
    possibleRangeProps = { 'min': props.min, 'max': props.max, 'step': props.step };
  }

  const formValidationModel = useContext(ValidationContext) as any;
  const fieldValidationModel = formValidationModel?.fields?.[props.dataField];

  const handleToggle = () => {
    if (type === 'password') {
      setIcon(<i className="far fa-eye-slash"></i>)
      setType('text')
    } else {
      setIcon(<i className="far fa-eye"></i>);
      setType('password')
    }
  }

  useEffect(() => {
    if (fieldValidationModel) {
      setIsValid(fieldValidationModel?.isValid !== undefined ? fieldValidationModel.isValid : true);
      setValidationModel(fieldValidationModel);
    }
  }, [fieldValidationModel?.isValid]);

  useEffect(() => {
    const fieldValidationModel = formValidationModel?.fields?.[props.dataField];
    if (fieldValidationModel) {
      setValidationModel(fieldValidationModel);
      setIsRequired(!props.disabled && (props.isRequired ?? fieldValidationModel?.isRequired));
    }
  }, []);

  //const isRequired = props.isRequired ?? props.validationModel?.isRequired;

  // useEffect(() => {
  //   const fieldValidationModel = formValidationModel?.[props.dataField];
  //   if (fieldValidationModel) {
  //     setIsValid(fieldValidationModel?.isValid !== undefined ? fieldValidationModel.isValid : true);
  //     setValidationModel(fieldValidationModel);
  //   }
  // }, [JSON.stringify(formValidationModel)]);

  // useEffect(() => {
  //   setIsValid(props.validationModel?.isValid !== undefined ? props.validationModel.isValid : true);
  // }, [props.validationModel?.isValid]);

  let label = props.label;
  let placeholder = props.placeholder;
  if (prefix) {
    label = t(`${prefix}.Fields.${props.dataField}`);
    placeholder = `${t(`${prefix}.Fields.${props.dataField}`)}...`;
  }

  return (
    <>
      <div
        className={isValid ? "row" : "row invalid"}
        style={{ justifyContent: props.justifyContent ?? "unset" }}
      >
        {label && (
          <label htmlFor={props.id} className={leftColumnClass} style={{ display: 'flex' }}>
            {label}{isRequired && <span className="required">*</span>}
            {
              props.isPassword && <div style={{ marginLeft: '10px' }} onClick={handleToggle}>
                <div>{icon}</div>
              </div>
            }
          </label>
        )}

        <div className={rightColumnClass}>
          <input
            defaultValue={props.defaultValue}
            id={props.id}
            {...valueProps}
            {...possibleRangeProps}
            type={props.isPassword ? type : props.isNumber ? "number" : "text"}
            className={`form-control`}
            placeholder={placeholder ? placeholder : ""}
            disabled={props.disabled}
            style={{ width: props.width!, textAlign: props.textAlign! }}
            autoComplete={props.autoComplete}
            onChange={(event) => {
              validateField(event.target.value, validationModel);
              if (props.handleCheckedChange) {
                props.handleCheckedChange(event.target.value);
              }
              else {
                props.formData[props.dataField] = event.target.value;
                if (props.setStateMethod) {
                  props.setStateMethod({ ...props.formData });
                }
              }
            }}
          />

          {validationModel?.errors &&
            <span className="validation-errors">
              {validationModel?.errors.map(e => {
                return e;
              })}
            </span>
          }
        </div>
      </div>
    </>
  );
};
